(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-style9"] && !Shopify.designMode) return;
  try {
    
    $(".gu").hover(
      function () {
        $(".gu").removeClass("nb");
        $(this).addClass("nb");
      }
    );


  } catch(e) { console.error(e); }
})();
})();
